/**
 * Plan cart constants and enumerations
 */

// Plan rule type enumeration
export const RuleType = {
  DEPENDENCY: 'dependency', // Dependency relationship
  EXCLUSION: 'exclusion', // Exclusion relationship
};

// Operation reason code enumeration
export const ReasonCode = {
  // Add reasons
  USER_ADD: 'USER_ADD', // User actively added
  USER_ADD_MATCH_CYCLE: 'USER_ADD_MATCH_CYCLE', // USER_ADD_MATCH_CYCLE
  DEPENDENCY_AUTO_ADD: 'DEPENDENCY_AUTO_ADD', // Dependency rule auto-added
  DEPENDENCY_UPDATE_CYCLE: 'DEPENDENCY_UPDATE_CYCLE',

  // Remove reasons
  USER_REMOVE: 'USER_REMOVE', // User remove
  EXCLUSION_CATEGORY_CONFLICT: 'EXCLUSION_CATEGORY_CONFLICT', // Exclusion rule cross-category conflict
  BUNDLE_REMOVE: 'BUNDLE_REMOVE', // Bundle rule replaces individual plan
  DEPENDENCY_CASCADE_REMOVE: 'DEPENDENCY_CASCADE_REMOVE', // Dependency rule cascade removal

  // Update reasons
  DEPENDENCY_LICENSE_ADJUST: 'DEPENDENCY_LICENSE_ADJUST', // License quantity adjusted due to dependency constraint
};

export const BILLING_CYCLE = {
  ONE_TIME: 'one_time',
  ONE_MONTH: 'one_month',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  ANNUAL_TERM_MONTHLY: 'annual_term_monthly',
  ANNUAL: 'annual',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
  PAY_AS_YOU_GO: 'payAsYouGo',
  PAY_PER_ATTENDEE: 'pay_per_attendee',
};

export const BillingCycleMap = {
  [BILLING_CYCLE.ONE_TIME]: 1,
  [BILLING_CYCLE.ONE_MONTH]: 1,
  [BILLING_CYCLE.MONTHLY]: 1,
  [BILLING_CYCLE.QUARTERLY]: 3,
  [BILLING_CYCLE.ANNUAL_TERM_MONTHLY]: 12,
  [BILLING_CYCLE.ANNUAL]: 12,
  [BILLING_CYCLE.TWO_YEARS]: 24,
  [BILLING_CYCLE.THREE_YEARS]: 36,
};
